import { createContext, useContext, useMemo, useState } from 'react';
import { getCurrentRegion, saveCurrentRegion } from 'utils/storage';

interface RegionContextValue {
  region: string | null;
  setRegion: (value: string | null) => void;
  isRegionModalRequired: boolean;
  setRegionModalRequired: (value: boolean) => void;
}

const RegionContext = createContext<RegionContextValue>({
  region: null,
  setRegion: () => {},
  isRegionModalRequired: false,
  setRegionModalRequired: () => {},
});

const normalizeRegion = (value?: string | null) => {
  if (!value || value === 'null' || value === 'undefined') {
    return null;
  }

  return value;
};

export const RegionProvider = ({
  children,
  initialRegion,
}: {
  children: React.ReactNode;
  initialRegion?: string | null;
}) => {
  const [region, setRegionState] = useState<string | null>(
    normalizeRegion(initialRegion ?? getCurrentRegion())
  );
  const [isRegionModalRequired, setRegionModalRequired] = useState(false);

  const setRegion = (value: string | null) => {
    const normalized = normalizeRegion(value);
    saveCurrentRegion(normalized);
    setRegionState(normalized);
  };

  const value = useMemo(
    () => ({
      region,
      setRegion,
      isRegionModalRequired,
      setRegionModalRequired,
    }),
    [region, isRegionModalRequired]
  );

  return (
    <RegionContext.Provider value={value}>{children}</RegionContext.Provider>
  );
};

export const useRegion = () => useContext(RegionContext);
